// Policy Attributes
export const POLICY_ATTRIBUTES_WARNING_MODAL_TEST_ID = 'policy-attributes-warning-modal';
export const POLICY_ATTRIBUTES_EDITABLE_FORM_TEST_ID = 'policy-attributes-editable-form';
export const POLICY_ATTRIBUTES_NOT_EDITABLE_FORM_TEST_ID = 'policy-attributes-not-editable-form';

// Plan attributes page
export const RFQ_PLAN_ATTRIBUTES_SPINNER_TEST_ID = 'rfq-plan-attributes-spinner';
export const RFQ_PLAN_ATTRIBUTES_BACK_BTN_TEST_ID = 'rfq-plan-attributes-back-btn';
export const RFQ_PLAN_ATTRIBUTES_ACTION_BTN_TEST_ID = 'rfq-plan-attributes-action-btn';
export const RFQ_PLAN_ACTION_BTN_TEST_ID = 'rfq-plan-action-btn';
export const WARNING_MODAL_TEST_ID = 'warning-modal-test-id';

// Configure attribute page
export const BACK_TO_PREV_FORM_BTN_TEST_ID = 'back-to-previous-form-btn';
export const BACK_TO_LIST_BTN_TEST_ID = 'back-to-list-btn';
export const SAVE_AND_RETURN_TO_LIST_BTN_TEST_ID = 'save-and-return-to-list-btn';
export const SAVE_AND_GO_TO_NEXT_FORM_BTN_TEST_ID = 'save-and-go-to-next-form-btn';
export const SAVE_AND_ADD_NEW_ATTR_BTN_TEST_ID = 'save-and-add-new-attr-btn';
export const CONFIGURE_ATTRIBUTE_FORM_TEST_ID = 'configure-attr-form-id';

// Generate PDF page
export const REVIEW_GENERATED_PDF_STEP_TEST_ID = 'review-generated-pdf-step';
export const SELECT_AND_GENERATE_PDF_STEP_TEST_ID = 'select-and-generate-pdf-step';
export const COMPLETE_GENERATE_PDF_STEP_TEST_ID = 'complete-generate-pdf-step';
export const COMPLETE_GENERATE_PDF_STEP_BTN_TEST_ID = 'complete-generate-pdf-step-btn';
export const GENERATE_PDF_BACK_BTN_TEST_ID = 'generate-pdf-back-button';
export const REGENERATE_PDF_GUIDELINES_TEST_ID = 'regenerate-pdf-guidelines';
export const ATTRIBUTES_SELECTION_LIST_TEST_ID = 'attributes-selection-list';
export const GENERATE_PDF_BTN_TEST_ID = 'generate-pdf-button';
export const GENERATE_PDF_PAGE_LOADING_TEST_ID = 'generate-pdf-page-loading';
export const GENERATE_PDF_COMPLETE_STEP_LOADING_TEST_ID = 'generate-pdf-complete-step-loading';
export const SELECT_ATTRIBUTE_CHECKBOX_TEST_ID = 'select-attribute-checkbox';
export const SELECT_AND_GENERATE_BLOCK_GUIDELINES_TEST_ID = 'select-and-generate-guidelines';
export const DOWNLOAD_GENERATED_PDF_BTN_TEST_ID = 'download-generated-pdf-btn';
export const TOGGLE_ATTRIBUTES_SECTION_BTN_TEST_ID = 'toggle-attributes-section-btn';

// Save product template page
export const SAVE_PRODUCT_TEMPLATE_SPINNER_TEST_ID = 'save-product-template-spinner';
export const SAVE_PRODUCT_TEMPLATE_FORM_TEST_ID = 'save-product-template-form';
export const SAVE_PRODUCT_TEMPLATE_STATISTICS_TEST_ID = 'save-product-template-statistics';
export const SAVE_PRODUCT_TEMPLATE_ATTRIBUTES_TEST_ID = 'save-product-template-attributes';
export const SAVE_PRODUCT_TEMPLATE_BACK_BTN_TEST_ID = 'save-product-template-back-btn';
export const SAVE_PRODUCT_TEMPLATE_COMPLETE_BTN_TEST_ID = 'save-product-template-complete-btn';

// Template checklist page
export const CHECKLIST_OPTIONS_SPINNER_TEST_ID = 'checklist-options-spinner';
export const CHECKLIST_OPTIONS_TEST_ID = 'checklist-options';
export const STAGE_CARD_CONTINUE_BTN_TEST_ID = 'stage-card-continue-btn';
export const STAGE_CARD_VIEW_EDIT_BTN_TEST_ID = 'stage-card-view-edit-btn';
export const STAGE_CARD_UNAVAILABLE_BTN_TEST_ID = 'stage-card-unavailable-btn';
export const STAGE_CARD_STATUS_TEST_ID = 'stage-card-status';
export const STAGE_CARD_TEST_ID = 'stage-card';

// Shared status tag test IDs (used by both rfq-product-templates and shelf-product-templates)
export const PRODUCT_TEMPLATES_READY_STATUS_TAG_TEST_ID = 'product-templates-ready-status-tag';
export const PRODUCT_TEMPLATES_ARCHIVE_STATUS_TAG_TEST_ID = 'product-templates-archive-status-tag';
export const PRODUCT_TEMPLATES_IN_PROGRESS_STATUS_TAG_TEST_ID = 'product-templates-in-progress-status-tag';
export const PRODUCT_TEMPLATES_INITIAL_SEED_STATUS_TAG_TEST_ID = 'product-templates-initial-seed-status-tag';

// Initial seed product templates
export const GROUP_MAINTENANCE_FORM_ID = 'group_maintenance_form_id';
export const RATE_MAINTENANCE_FORM_ID = 'rate_maintenance_form_id';
